import { Injectable } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { SortColumn, SortDirection } from '../../../pages/nft-marketplace/explore/explore-sortable.directive';
import { TemplateSearchModel } from 'src/app/core/models/document/template-search-model';
import { GlobalComponent } from 'src/app/global-component';
import { DocumentTemplateModel, TemplateDocumentType } from 'src/app/core/models/document/document-template-model';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { CategoryModel } from 'src/app/core/models/document/category-model';
import { CategorySearchModel } from 'src/app/core/models/document/category-search-model';

// Range Slider
import { BaseListService } from 'src/app/core/services/list-services/base-list.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EntityTypeEnum } from '../../enums/entity-type-id-enum';


export class TemplateListState extends TemplateSearchModel {
  sortColumnDirective?: SortColumn;
  sortDirectionDirective?: SortDirection;
  startIndex: number = 0;
}

@Injectable({ providedIn: 'root' })
export class ExploreService extends BaseListService {

  public static searchId: string | undefined;

  defaultExploreState: TemplateListState = {
    sortColumnDirective: "name",
    sortDirectionDirective: "",
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 1,
    sortColumn: "",
    sortDirection: "Asc",
    searchTerm: "",
    documentTypes: [TemplateDocumentType.Document, TemplateDocumentType.Retainer, TemplateDocumentType.Marketplace],
    categoryId: "",
  };

  private _resultItems$ = new BehaviorSubject<DocumentTemplateModel[]>([]);

  private _categories$ = new BehaviorSubject<CategoryModel[]>([]);

  protected override _state: TemplateListState = { ...this.defaultExploreState };

  private pages: number = 0;

  constructor(
    private myFileApiService: MyfileApiService,
    private sanitizer: DomSanitizer,
    private _titleCasePipe: TitleCasePipe
  ) {
    super();

    this._getCategories().subscribe((result: SearchResultModel<CategoryModel> | undefined) => {
      if (result) {
        var emptyCategory = new CategoryModel();
        emptyCategory.id = "";
        emptyCategory.name = "Select Category";

        //always set Select Category to be fist element
        result.items.splice(0, 0, emptyCategory);

        this._categories$.next(result.items);
      }
    });

    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))

    ).subscribe((result: any) => {
      result.items.forEach((x: DocumentTemplateModel) => {
        x.isIcon = false;
        if (x.coverPhotoFileId) {
          if (x.coverImageURL == undefined) {
            this.loadCoverPhoto(x);
          }
        }
      });

      this._resultItems$.next(result.items);
      this._total$.next(result.count);
      this.pages = (((result.count - (result.count % this.pageSize)) / this.pageSize) + 1)
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get categoryId() { return this._state.categoryId; }
  get categories$() { return this._categories$.asObservable(); }

  set name(name: string) { this._set({ name }); }
  set categoryId(categoryId: any) { this._set({ categoryId }); }
  set categoryIdNoName(categoryId: any) { this._state.name = undefined; this._set({ categoryId }); }

  protected _search(): Observable<SearchResultModel<DocumentTemplateModel> | undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getDocumentTemplates(this._state);
  }

  public searchByName(name: string): Observable<SearchResultModel<DocumentTemplateModel> | undefined> {
    this._state = this.defaultExploreState;
    this.validateStartIndex();
    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;
    this._state.name = name;

    return this.myFileApiService.getDocumentTemplates(this._state);
  }

  clearListService() {
    this._state = { ...this.defaultExploreState };
    this._resultItems$.next(new Array<DocumentTemplateModel>());
    this._total$.next(0);
  }

  private _getCategories(): Observable<SearchResultModel<CategoryModel> | undefined> {
    var search = new CategorySearchModel();
    search.sortColumn = "Name";
    search.sortDirection = "Asc";

    return this.myFileApiService.getDocumentCategories(search);
  }

  private loadCoverPhoto(model: DocumentTemplateModel) {
    this.myFileApiService.getEntityFile(EntityTypeEnum.DocumentTemplate, model.id!, model.coverPhotoFileId!).subscribe(result => {
      if (result) {
        var reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onload = () => {
          if (reader.result) {

            model.coverImageURL = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${reader.result.toString().split(',')[1]}`);
          }
        }
      } else {
        model.coverImageURL = GlobalComponent.defaultDocumentImageUrl;
      }
    });
  }

}